import {
  Accordion,
  AccordionButton,
  AccordionItem,
  Box,
  Flex,
  Icon,
  Image,
  Stack,
  Text,
  theme,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { navItems } from "../../utils/Data/data";
import AuthContext from "../Auth/AuthContext";
import CustomAccordion, { hasActiveChild } from "./CustomAccordion";
import { SidebarUserDetails } from "./SideBar";
import SearchInput from "./SearchInput";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import { debounce } from "lodash";
import { getHostDomain } from "../../utils/utils";
import { fetchController } from "../../utils/FetchController/fetchController";
import { Link, useLocation } from "react-router-dom";
import { FiHome } from "react-icons/fi";

const NewSideBar = () => {
  const baseUrl = getHostDomain();
  const { colorMode } = useColorMode();

  const { authUser, logout } = useContext(AuthContext);
  const userName =
    authUser?.first_name?.length > 15
      ? `${authUser?.first_name?.slice(0, 10)}...`
      : authUser?.first_name;
  const onClickLogout = () => {
    logout();
  };

  const [options, setOptions] = useState([]);
  const [text, setText] = useState("");
  const [tag, setTag] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const debouncedFetch = debounce(async (query) => {
      if (query.trim().length < 3) {
        setOptions([]);
        return;
      }

      const urlHit = `${baseUrl}/api/v1/link_tag_entity/search/entities?tag_term=${query}&page=1&size=50`;

      try {
        setLoading(true);
        const response = await fetchController(urlHit, "GET");
        setOptions(response.data.items[0]?.entities || []);
        setTag(response.data.items[0]?.tag);
      } catch (error) {
        console.error("Error fetching data:", error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 500);

    debouncedFetch(text);

    return () => debouncedFetch.cancel();
  }, [text, baseUrl]);
  function onTextChange(text) {
    setText(text);
  }
  function onChange(value) {
    setText(value);
  }

  const agency = useContext(AgencyContext);
  const { myDetails } = agency;
  const agencyLogoUrl = myDetails ? myDetails?.branding?.logo_url : null;
  const logo = !agency.loading ? (
    myDetails?.agency_id ? (
      agencyLogoUrl ? (
        <Image
          width="100px"
          src={
            agencyLogoUrl.includes(window.origin)
              ? agencyLogoUrl
              : `${window.location.origin}${agencyLogoUrl}`
          }
          alt={`${myDetails?.branding?.agency_name}-logo`}
        />
      ) : null
    ) : (
      <Image width="150px" src="/logo/indightoai.png" alt="Insighto.ai" />
    )
  ) : null;

  const location = useLocation();

  const isAnyNavItemActive = navItems.some((navItem) =>
    hasActiveChild(navItem, location.pathname)
  );
  const textColor = agency?.textColor;
  const iconColor = useColorModeValue(
    textColor || theme.colors.gray[500],
    "white"
  );
  const isActive = location.pathname.includes(window.location.path);
  const activeTitleColor =
    colorMode === "light"
      ? isActive
        ? textColor || "black"
        : "gray"
      : "white";
  return (
    <Flex
      justifyContent={"center"}
      alignItems={"space-between"}
      flexDir={"column"}
      gap={3}
      h={"100%"}
      w={"100%"}
    >
      <Stack p={2} justifyContent={"space-between"} alignItems="center" gap={2}>
        <div
          style={{
            color: "#3182ce",
          }}
        >
          {logo}
        </div>

        <SearchInput
          options={options}
          value={text}
          onChange={onChange}
          onTextChange={onTextChange}
          loading={loading}
          tag={tag}
        />
      </Stack>
      <Box
        overflowY={"auto"}
        w={"100%"}
        flex={1}
        borderRadius={"md"}
        sx={{
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Accordion w={"100%"}>
          <AccordionItem
            bg={isActive ? "gray.200" : undefined}
            borderBottomWidth={"0px !important"}
          >
            <AccordionButton px={4} py={2} justifyContent={"space-between"}>
              <Link
                to={"/dashboard"}
                style={{ width: "100%", textAlign: "left" }}
              >
                <Flex alignItems={"center"} gap={3}>
                  <Icon as={FiHome} size="md" color={iconColor} />
                  <Text fontWeight={"bold"} color={activeTitleColor}>
                    {"Overview"}
                  </Text>
                </Flex>
              </Link>
            </AccordionButton>
          </AccordionItem>
        </Accordion>

        {navItems
          .filter(
            (navItem) =>
              !(myDetails?.agency_id && navItem.id === "manage_agency")
          )
          .map((navItem, index) => {
            return (
              <CustomAccordion
                key={index}
                navItem={navItem}
                forceOpen={!isAnyNavItemActive && navItem.title === "Build"}
              />
            );
          })}
      </Box>

      <SidebarUserDetails
        navSize={"large"}
        user={authUser}
        onClickLogout={onClickLogout}
        userName={userName}
      />
    </Flex>
  );
};

export default NewSideBar;
